(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('SurveyModalPhysicalFairController', SurveyModalPhysicalFairController)

        SurveyModalPhysicalFairController.$inject = ['$uibModalInstance', 'physicalFair', 'SendSurveyService'];

    function SurveyModalPhysicalFairController($uibModalInstance, physicalFair, SendSurveyService) {
        var vm = this;

        vm.physicalFair     = physicalFair;
        vm.survey_url      = '';
        vm.attended        = 0;
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.send            = send;

        activate();

        function activate() {
            console.log(vm.physicalFair);
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function send() {
            var data = {
                expo_id: vm.physicalFair.id,
                survey_url: vm.survey_url,
                expo_location_id: vm.physicalFair.expo_location_id,
                attended: vm.attended
            }

            SendSurveyService.sendSurveyPhysicalFair(data)
            .then(function(response){
                alertify.notify('Emails sent successfully!', 'success', 3);
                window.location.reload();
            }).catch(function(err) {
                alertify.notify(err, 'danger', 3);
            });
        }

    }

})();